export const ACCORDION = 'spp_accordion';
export const ADD_TO_BAG_BUTTON = 'add_to_bag_btn';
export const ADD_TO_BAG_BUTTON_DISABLED = 'add_to_bag_btn_disabled';
export const ADD_TO_COLLECTION_BUTTON = 'add_to_collection_btn';
export const AFTER_PAY = 'after_pay';
export const KUESKI = 'kueski_pay';
export const ATOME = 'atome_pay';
export const ALL_SIZES_LABEL_FEATURE = 'all_sizes_label_feature';
export const ANCHOR_LINK_FEATURE = 'anchor_link_feature';
export const AUTO_REPLENISH_FEATURE = 'auto_replenish_feature';
export const AUTO_REPLENISH_VIEW = 'autoReplenishView';
export const BEST_SHADE_MESSAGE = 'best-shade-message';
export const BEST_SHADE_NAME = 'best-shade-name';
export const BEST_USED_BY_MESSAGE = 'best_used_by_message';
export const BOPIS_FEATURE = 'bopis-feature';
export const BREAKPOINTS_WRAPPER = 'breakpoints-wrapper';
export const CART_PRODUCT_QUANTITY = 'cart_product_quantity';
export const CLICKABLE_WRAPPER = 'clickable_wrapper';
export const COLLAPSIBLE_CLOSE_BUTTON = 'collapsible_close_button';
export const COLLAPSIBLE_WRAPPER = 'collapsible_wrapper';
export const D_T_ID = 'd-t-id';
export const DISCOUNT_LOYALTY_MESSAGE = 'discount-loyalty-message';
export const DISCOUNT_PERCENT = 'discount-percent';
export const FIND_IN_STORE_BUTTON_FEATURE = 'find_in_store_button_feature';
export const FREE_SHIPPING_AND_RETURN_FEATURE = 'free_shipping_and_return_feature';
export const LIVE_CHAT = 'LIVE_CHAT';
export const MPP_ADD_TO_BAG = 'mpp_add_to_bag';
export const MPP_PRODUCT_DETAILS = 'mpp_product_details';
export const MPP_PRODUCT_SORTING_DROPDOWN = 'elc-product-sorting-dropdown';
export const MPP_SHADE_NAME = 'mpp_shade_name';
export const MPP_SHADE_SELECT = 'mpp_shade_select';
export const MPP_SORT_BY = 'mpp_sort_by';
export const ONSALE_TODAY_LABEL = 'onsale-today-label';
export const OVERLAY_CLOSE_BUTTON = 'overlay_close_button';
export const PERFECT_FOR_FEATURE = 'perfect_for_feature';
export const PREORDER_BUTTON = 'preorder_button';
export const PREORDER_BUTTON_DISABLED = 'preorder_button_disabled';
export const PREORDER_NOT_AVAILABLE_MESSAGE = 'preorder_not_available_message';
export const PRODUCT_ACCORDION = 'product_accordion';
export const PRODUCT_ATTRIBUTE = 'product_attribute';
export const PRODUCT_ATTRIBUTE_CONTENT = 'product_attribute_content';
export const PRODUCT_ATTRIBUTE_LABEL = 'product_attribute_label';
export const PRODUCT_ATTRIBUTES = 'product_attributes';
export const PRODUCT_BASIC_INFO = 'product_basic_info';
export const PRODUCT_BRIEF = 'product_brief';
export const PRODUCT_CAROUSEL = 'product_carousel';
export const PRODUCT_COMPARISON_MODULE = 'product_comparison_module';
export const PRODUCT_DESCRIPTION = 'product_description';
export const PRODUCT_DESCRIPTION_READ_MORE = 'product_description_read_more';
export const PRODUCT_ENGRAVING = 'product_engraving';
export const PRODUCT_ENGRAVING_LINK = 'product_engraving_link';
export const PRODUCT_FRAGRANCE_KEY_NOTES = 'product_fragrance_key_notes';
export const PRODUCT_GREAT_TO_KNOW = 'product_great_to_know';
export const PRODUCT_GRID_WRAPPER = 'product_grid_wrapper';
export const PRODUCT_GRID_HEADER = 'product_grid_header';
export const PRODUCT_GRID_SUBHEADER = 'product_grid_header';
export const PRODUCT_HOW_TO_USE = 'product_how_to_use';
export const PRODUCT_HOW_TO_USE_CONTENT = 'product_how_to_use_content';
export const PRODUCT_HOW_TO_USE_HEADER = 'product_how_to_use_header';
export const PRODUCT_IMAGE_BADGE = 'product-image-badge';
export const PRODUCT_IMAGE_CAROUSEL = 'product-image-carousel';
export const PRODUCT_INFO_POP_UP = 'product_info_pop_up';
export const PRODUCT_INFO_POP_UP_CONTENT = 'product_info_pop_up_content';
export const PRODUCT_INGREDIENTS = 'product_ingredients';
export const PRODUCT_INGREDIENTS_DISCLAIMER = 'product_ingredients_disclaimer';
export const PRODUCT_KEY_INGREDIENT = 'productKeyIngredient';
export const PRODUCT_KEY_INGREDIENT_ACCORDION_CONTENT = 'productKeyIngredientAccordionContent';
export const PRODUCT_KEY_INGREDIENT_FEATURE = 'productKeyIngredientFeature';
export const PRODUCT_KEY_INGREDIENT_ROW_CONTENT = 'productKeyIngredientRowContent';
export const PRODUCT_LEARN_MORE_LINK = 'product_learn_more_link';
export const PRODUCT_NAME = 'product_name';
export const PRODUCT_OVERVIEW_SUMMARY = 'spp_product_overview_summary';
export const PRODUCT_PRICE = 'product_price';
export const PRODUCT_PRICE_PER_UNIT = 'product_price_per_unit';
export const PRODUCT_PRICE_RANGE = 'product_price_range';
export const PRODUCT_PROMO_BANNER = 'product-promo-banner';
export const PRODUCT_RATING = 'product_rating';
export const PRODUCT_SHADE_DESCRIPTION = 'product_shade_description';
export const PRODUCT_SHORT_DESCRIPTION = 'product_short_description';
export const PRODUCT_SIZE = 'product_size';
export const PRODUCT_SIZE_DROPDOWN = 'product_size_dropdown';
export const PRODUCT_SIZE_PICKER_ROW = 'product_size_picker_row';
export const PRODUCT_SIZE_THUMBNAILS = 'product_size_thumbnails';
export const PRODUCT_SUBDISPLAY_NAME = 'product_subdisplay_name';
export const PRODUCT_SUBHEADER = 'product_subheader';
export const PRODUCT_TOUT_WRAPPER = 'product_tout_wrapper';
export const PRODUCT_USAGE_FIELD = 'product_usage_field';
export const PRODUCT_USAGE_FIELD_ACCORDION = 'product_usage_field_accordion';
export const QUICKSHOP_BUTTON_FEATURE = 'quickshop_button_feature';
export const RATINGS_AND_REVIEWS_FEATURE = 'ratings-and-reviews-feature';
export const SELECT_YOUR_SHADE_LABEL_FEATURE = 'select_your_shade_label_feature';
export const SELECTED_SIZE_FEATURE = 'selected_size_feature';
export const SHADE_DESCRIPTION_FEATURE = 'shade_description_feature';
export const SHADE_ICON = 'shade_icon';
export const SHADE_ICON_IMAGE = 'shade_icon_image';
export const SHADE_IMAGE_WRAPPER = 'shade_image_wrapper';
export const SHADE_PICKER_CAROUSEL = 'shade_picker_carousel';
export const SHADE_SIDEBAR_IMAGE = 'shade-sidebar-image';
export const SHADE_SWATCH_FEATURE = 'shade_swatch_feature';
export const SHADES_SIDE_BAR_BUTTON = 'spp_product_shades_sidebar_button';
export const SHIPS_BY_MESSAGE = 'ships_by_message';
export const SINGLE_SHADE_WRAPPER = 'single_shade_wrapper';
export const SKU_BENEFIT = 'sku_benefit';
export const SKU_ITEMS = 'skuItems';
export const SKU_PICKER = 'skuPicker';
export const SOCIAL_SHARE = 'product_social_share';
export const SOCIAL_SHARE_ICONS = 'product_social_share_icons';
export const SOCIAL_SHARE_WRAPPER = 'product_social_share_wrapper';
export const SPINNER_CONTAINER = 'spinner_container';
export const STICKY_PRODUCT_NAME = 'spp_sticky_product_name';
export const STICKY_PRODUCT_PRICE = 'spp_sticky_product_price';
export const STICKY_PRODUCT_SIZE = 'spp_sticky_product_size';
export const SUBSCRIBE_BUTTON = 'product_autoreplenish_subscribe_button';
export const TAX_INCLUDED = 'tax-included';
export const TEXT_BADGE = 'text-badge';
export const TRANSLATION_FIELD = 'translation-field';

export const VTO_ALL_SHADES_BUTTON = 'vto-button-all-shades';
export const VTO_FOUNDATION_BUTTON = 'vto-button-foundation';
export const VTO_MAKEUP_BUTTON = 'vto-button-makeup';
export const VTO_PERFECT_SHADES_BUTTON = 'vto-button-perfect-shades';
export const VTO_SHADE_SELECT = 'vto_shade_select';
